"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _invoices = require("@module/invoices");

var _app = require("@package/app");

var _dialog = require("@package/dialog");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _CancelForm = _interopRequireDefault(require("./CancelForm"));

var _excluded = ["data"];

function CancelProcess(_ref) {
  var data = _ref.data,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  try {
    var handleReset = function handleReset() {
      dispatch((0, _dialog.closeDialog)("invoice-cancel"));
    };

    var handleSubmit = function handleSubmit(value) {
      dispatch((0, _invoices.createCancel)((0, _objectSpread2["default"])({
        id: data['id'],
        externalId: data['externalId'],
        reason: value['reason']
      }, data)));
      dispatch((0, _dialog.closeDialog)("invoice-cancel"));
    };

    var dispatch = (0, _reactRedux.useDispatch)();
    return /*#__PURE__*/_react["default"].createElement(_CancelForm["default"], Object.assign({}, props, {
      initialValues: {
        reason: "\u041E\u0442\u043C\u0435\u043D\u0430 \u043F\u043E \u0441\u0447\u0435\u0442\u0443 (".concat(data['externalId'], ")")
      },
      onReset: handleReset,
      onSubmit: handleSubmit
    }));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = CancelProcess;
exports["default"] = _default;